import { render, staticRenderFns } from "./HubNewBadge.vue?vue&type=template&id=9876693c&scoped=true&"
import script from "./HubNewBadge.vue?vue&type=script&lang=js&"
export * from "./HubNewBadge.vue?vue&type=script&lang=js&"
import style0 from "./HubNewBadge.vue?vue&type=style&index=0&id=9876693c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9876693c",
  null
  
)

export default component.exports